export const translationKeys = [
    'card-information.header.label',
    'card.number.placeholder',
    'card.number.aria-label',
    'card.number.errors.required',
    'card.number.errors.min-length',
    'card.number.errors.invalid-number',
    'card.save.label',
    'card.saved-cards.choose-card.label',
    'card.saved-cards.clear-card.label',
    'card.saved-cards.saved-card.aria-label',
    'card.billing-name.placeholder',
    'card.billing-name.aria-label',
    'card.billing-name.errors.required',
    'card.billing-name.errors.min-length',
    'card.expiry.placeholder',
    'card.expiry.aria-label',
    'card.expiry.errors.required',
    'card.expiry.errors.pattern',
    'card.expiry.errors.expired',
    'card.cvc.placeholder',
    'card.cvc.aria-label',
    'card.cvc.errors.required',
    'card.cvc.errors.min-length',
    'card.cvc.errors.max-length',
    'billing-address.same-as-shipping.label',
    'billing-address.country.placeholder',
    'billing-address.country.aria-label',
    'billing-address.country.errors.required',
    'billing-address.zip.placeholder',
    'billing-address.zip.aria-label',
    'billing-address.zip.errors.required',
    'billing-address.zip.errors.min-length',
    'pay-button.label',
    'pay-button.aria-label',
    'payment-methods.show-less.label',
    'payment-methods.show-more.label',
    'payment-methods.paypal.label',
    'payment-methods.paypal.aria-label',
    'payment-methods.klarna.label',
    'payment-methods.klarna.aria-label',
    'payment-methods.applepay.label',
    'payment-methods.applepay.aria-label',
    'payment-success-state.label',
    // error messages
    'error.invalid_cvc',
    'error.authorization_required',
    'error.contact_card_issuer',
    'error.unsupported_card',
    'error.insufficient_funds',
    'error.unsupported_currency',
    'error.card_rejected',
    'error.expired_card',
    'error.suspected_fraud',
    'error.general_decline',
    'error.incorrect_number',
    'error.incorrect_pin',
    'error.invalid_address',
    'error.invalid_card_or_account',
    'error.invalid_amount',
    'error.invalid_date',
    'error.lost_restricted_or_stolen_card',
    'error.blocked_list',
    'error.not_permitted',
    'error.offline_or_online_pin_required',
    'error.pin_retry_exceeded',
    'error.processing_error',
    'error.withdrawal_count_limit_exceeded',
    'error.unknown',
    'error.fraud',
    'error.three_d_secure',
    'error.custom_rule',
];
//# sourceMappingURL=translation.js.map